import React from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import './Pricing.css';

const PRICE_LINK = 'https://linkly.link/2W3Uk';

const Pricing = () => {
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);

  return (
    <section id="pricing" className="pricing">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('pricingTitle')}</h2>
          <p className="section-subtitle">
            {t('pricingSubtitle')}
          </p>
        </div>

        <div className="pricing-single">
          <a
            href={PRICE_LINK}
            className="pricing-card pricing-card-single popular"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="plan-price-block">
              <span className="price-symbol">₪</span>
              <span className="price">15,000</span>
              <span className="plan-period">{t('pricePerMonth')}</span>
            </div>
            <ul className="plan-features">
              <li className="feature-item">{t('feature1')}</li>
              <li className="feature-item">{t('feature2')}</li>
            </ul>
            <span className="btn btn-pricing">{t('ctaStart')}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Pricing;

